import { useAuth } from '../services/AuthContext';

export const usePartnerType = () => {
    const { user } = useAuth();
    const role = user?.role || 'GUEST';
    
    // In our system:
    // PARTNER = Individual Broker / Freelancer
    // COMPANY_OWNER = Enterprise / Brokerage Owner
    
    return {
        isCompanyOwner: role === 'COMPANY_OWNER',
        isFreelancer: role === 'PARTNER',
        isGuest: role === 'GUEST',
        role
    };
};
